import React, { Component } from 'react';
import { connect } from 'react-redux';

class Home extends Component {
    render() {
        let REACT_APP_APIURL= process.env.REACT_APP_APIURL;
        return (
            <div>
                <h1>Backoffice Front</h1>  
                <h3>API CONECT - {REACT_APP_APIURL}</h3> 
            </div>
            );
    }
}
export default connect()(Home);
